var _title, _desc, _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReply = function SvgReply(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "26px",
    viewBox: "0 0 30 26",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "responde_Stroke 9")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .main { stroke: #A8A8A7 }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LIbraway_loggato",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ricetta_new",
    transform: "translate(-878.000000, -2265.000000)",
    className: "main",
    strokeWidth: 1.938
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(807.000000, 2255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0871562,25.4881618 L94.4395397,25.4881618 L78.0871562,25.4881618 Z M78.0871562,21.4307685 L94.4395397,21.4307685 L78.0871562,21.4307685 Z M78.0871562,17.5622292 L94.4395397,17.5622292 L78.0871562,17.5622292 Z M97.9729644,11.4872629 L74.2277589,11.4872629 C73.3287452,11.4872629 72.5993753,12.2164764 72.598389,13.1182292 L72.598389,29.3176449 C72.5993753,30.2189034 73.3287452,30.9496 74.2277589,30.9496 L77.4179507,30.9496 C77.6038685,30.9496 77.7542795,31.1008809 77.7542795,31.2872629 L77.7542795,33.9559371 C77.7542795,34.2496 78.1024438,34.402364 78.3184438,34.2041169 L81.7542247,31.0385888 C81.8163616,30.9807461 81.8972384,30.9496 81.9815671,30.9496 L97.9729644,30.9496 C99.0574027,30.9496 99.9371836,30.0681169 99.9371836,28.979982 L99.9371836,13.4558921 C99.9371836,12.3687461 99.0574027,11.4872629 97.9729644,11.4872629 Z",
    id: "Stroke-9"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReply, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reply.1c24d6b8.svg";
export { ForwardRef as ReactComponent };